import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { TickCircle } from "iconsax-react";
import { useTranslation } from "react-i18next";

import { CREATE_SHOP_STEPS } from "@/hooks/useCreateShopPage";
import type { CreateShopStepperProps } from "./CreateShopStepper.types";
import * as styles from "./CreateShopStepper.styles";

export type { CreateShopStepperProps } from "./CreateShopStepper.types";

export function CreateShopStepper({
  setStep,
  stepperProgressPercent,
  getStepState,
  canNavigateToStep,
}: CreateShopStepperProps) {
  const { t } = useTranslation("shops");
  const theme = useTheme();

  return (
    <Box sx={styles.card}>
      <Box sx={styles.row}>
        <Box sx={styles.line}>
          <Box sx={styles.track} />
          <Box sx={styles.progress(stepperProgressPercent)} />
        </Box>
        {CREATE_SHOP_STEPS.map((stepKey, index) => {
          const state = getStepState(index);
          const clickable = canNavigateToStep(index);
          return (
            <Box
              key={stepKey}
              sx={styles.item(clickable)}
              onClick={() => {
                if (clickable) setStep(stepKey);
              }}
            >
              <Box sx={styles.dot(state)}>
                {state === "done" ? (
                  <TickCircle size={16} variant="Bold" color={theme.palette.primary.contrastText} />
                ) : (
                  index + 1
                )}
              </Box>
              <Typography sx={styles.label(state !== "upcoming")}>{t(`steps.${stepKey}`)}</Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
